module.exports = __webpack_public_path__ + "cccff0d9871a59a6c26573bf8daf317b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg60.jpeg
// module id = 73
// module chunks = 0